module.exports = (__webpack_require__(0))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./src/rest.js from dll-reference girder_lib
// module id = 4
// module chunks = 0